import gsap from 'gsap';
import _ from 'underscore';
import PerfectScrollbar from 'perfect-scrollbar';
import ClickOutside from 'vue-click-outside';
import Axios from 'axios';

export default {
    props: {
        searchUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            triggers: {},
            background: {},
            navMain: {},
            sideMenuOpen: false,
            navSide: {},
            searchOpen: false,
            searchQuery: '',
            wait: 500,
            elapsed: 0,
            loading: false,
            searchResults: [],
            emptyResults: false,
            $observer: null,
            $ps: null,
            results: null,
            bodyClass: '',
            resultsCount: null
        };
    },

    computed: {
        showNavActions() {
            return {
                'd-flex': this.sideMenuOpen && !this.searchOpen
            };
        }
    },

    watch: {
        searchQuery: function(val) {
            if (this.elapsed != 0) {
                clearInterval(this.elapsed);
            }
            if (val != '') {
                this.elapsed = setInterval(this.applySearch, this.wait);
            } else {
                this.searchResults = [];
                this.resultsCount = 0;
            }
            this.emptyResults = false;
        }
    },

    methods: {
        handleEnter: function(e) {
            if (!this.sideMenuOpen) {
                e.target.classList.add('trigger-enter'); // triggers display: block
                setTimeout(
                    () => e.target.classList.add('trigger-enter-active'),
                    150
                ); // triggers opacity: 1
                this.background.classList.add('open'); // show background

                const submenu = e.target.querySelector('.submenu');
                const submenuCoords = submenu.getBoundingClientRect();
                const navCoords = this.navMain.getBoundingClientRect();

                const coords = {
                    height: submenuCoords.height,
                    width: submenuCoords.width,
                    top: submenuCoords.top - navCoords.top,
                    left: submenuCoords.left - navCoords.left
                };

                this.background.style.setProperty('width', `${coords.width}px`);
                this.background.style.setProperty(
                    'height',
                    `${coords.height}px`
                );
                this.background.style.setProperty(
                    'transform',
                    `translate(${Math.round(coords.left)}px, ${coords.top}px)`
                );
            }
        },
        logout: function() {
            Axios.get('/ledennet/aad-signout').then(response => {
                if (response.status == 200) {
                    window.location.reload();
                }
            });
        },
        handleLeave: function(e) {
            this.background.classList.remove('initial'); // remove initial state so that transforms are now transitioned as well
            e.target.classList.remove('trigger-enter', 'trigger-enter-active');
            this.background.classList.remove('open');
            this.background.style.setProperty('height', `0px`);
        },

        toggleSideMenu: function(e) {
            if (e.target.className != 'nav-actions__item') {
                if (this.sideMenuOpen && this.searchOpen) {
                    this.searchOpen = false;
                }
                this.searchQuery = '';
                this.sideMenuOpen = !this.sideMenuOpen;
            }
        },

        toggleSearch: function() {
            if (window.innerWidth < 1400) {
                this.sideMenuOpen = true;
                this.searchOpen = true;
            }
            if (this.searchQuery.length) {
                this.sideMenuOpen = true;
                this.searchOpen = true;
                window.history.pushState(
                    '',
                    '',
                    this.searchUrl + '?q=' + this.searchQuery
                );
                this.$gtag.pageview(this.searchUrl + '?q=' + this.searchQuery);
            } else {
                if (this.searchOpen) {
                    this.searchOpen = !this.searchOpen;
                }
            }

            if (this.searchOpen) {
                this.$nextTick(() =>
                    this.$refs.search.querySelector('input').focus()
                );
            }
        },

        updateScrollPosition: function() {
            window.scrollY >= 100
                ? this.bodyClass.add('nav--sticky')
                : this.bodyClass.remove('nav--sticky');
        },

        updateScrollPositionIE: function(e) {
            e.preventDefault();
            const position = e.wheelDelta
                ? window.pageYOffset - e.wheelDelta
                : window.pageYOffset;
            position > 100
                ? this.bodyClass.add('nav--sticky')
                : this.bodyClass.remove('nav--sticky');
            window.scrollTo(0, position);
        },

        toggleCollapse: function(e) {
            e.target.classList.toggle('open');
        },

        applySearch() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            const url =
                '/umbraco/api/search/search?q=' +
                this.searchQuery +
                '&contentid=' +
                document
                    .getElementsByTagName('body')[0]
                    .getAttribute('data-root-page');
            Axios.get(url).then(response => {
                if (response.status == 200 && response.data.result) {
                    this.searchResults = response.data.data.splice(0, 5);
                    this.resultsCount = response.data.results;
                    if (this.searchResults.length == 0) {
                        this.emptyResults = true;
                    }
                    this.loading = false;
                }
            });
        },

        beforeEnter: function(el) {
            el.style.opacity = 0;
            el.style.transform = 'translateY(-10px)';
        },
        enter: function(el, done) {
            const delay = el.dataset.index * 100;
            setTimeout(function() {
                gsap.to(el, 0.2, { opacity: 1, y: 0, onComplete: done });
            }, delay);
        },
        leave: function(el, done) {
            el.style.opacity = 0;
            done();
        }
    },

    mounted() {
        this.triggers = this.$el.querySelectorAll(
            '.nav-main .mainmenu > li.has-submenu'
        );
        this.background = this.$el.querySelector('.dropdown-background');
        this.navMain = this.$el.querySelector('.nav-main');
        this.navSide = this.$el.querySelector('.nav-side');

        this.$ps = new PerfectScrollbar(this.navSide.querySelector('ul'), {
            suppressScrollX: true
        });

        this.$results = new PerfectScrollbar(this.$refs.results, {
            suppressScrollX: true
        });

        this.triggers.forEach(trigger =>
            trigger.addEventListener('mouseenter', this.handleEnter)
        );
        this.triggers.forEach(trigger =>
            trigger.addEventListener('mouseleave', this.handleLeave)
        );

        this.bodyClass = document.body.classList;
        const updateScroll = _.throttle(this.updateScrollPosition, 33);
        const rootClass = document.documentElement.getAttribute('class');

        if (rootClass && rootClass.indexOf('ie') != -1) {
            window.addEventListener('mousewheel', this.updateScrollPositionIE);
        } else {
            window.addEventListener('scroll', updateScroll); // lazy
        }
    },

    directives: {
        ClickOutside
    }
};
